
  
  export const allIngredients = [
    { icon: "🧀", label: "Ask a Question", code: "ask" },
    { icon: "🥕", label: "My Questions", code: "my" },
    { icon: "🥂", label: "Community Questions", code: "com" }
  ];
  
  const [tomato, lettuce, cheese] = allIngredients;
  export const initialTabs = [tomato, lettuce, cheese];
  
  export function getNextIngredient(
    ingredients
  ) {
    const existing = new Set(ingredients);
    return allIngredients.find((ingredient) => !existing.has(ingredient));
  }
  